import { combineReducers } from "redux";

class Error {
  resource;
  code;
  description;

  constructor(resource, code, description) {
    this.resource = resource;
    this.code = code;
    this.description = description;
  }
}

function SuspensionReducer() {
  const clientInitialState = {
    clients: [],
    selectedClient: {},
    resourceLoading: [],
    resourceErrors: [],
  };
  const suspensionInitialState = {
    suspensions: [],
    suspensionTypes: [],
    suspensionHistory: [],
    selectedSuspension: {},
    resourceLoading: [],
    resourceErrors: [],
    suspensionAddedSuccess: false,
    suspensionUpdatedSuccess: false,
    suspensionDeletedSuccess: false,
    groupMemberships: [],
    groupMembershipsSuccess: null,
  };

  const client = (state = clientInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_SUSPENSIONS_CLIENTS_INIT":
        return {
          ...state,
          clients: action.payload,
          resourceLoading: state.resourceLoading.concat([
            "GET_SUSPENSIONS_CLIENTS",
          ]),
          resourceErrors: [],
        };
      case "GET_SUSPENSIONS_CLIENTS_SUCCESS":
        return {
          ...state,
          clients: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSIONS_CLIENTS",
          ),
          resourceErrors: [],
        };
      case "GET_SUSPENSIONS_CLIENTS_ERROR":
        return {
          ...state,
          clients: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSIONS_CLIENTS",
          ),
          resourceErrors: state.resourceErrors.concat([
            new Error(
              "GET_SUSPENSIONS_CLIENTS",
              "FAILED_TO_LOAD",
              "Failed to load clients. Please try again later.",
            ),
          ]),
        };
      case "UPDATE_SUSPENSIONS_CLIENT":
        return {
          ...state,
          clients: action.payload
        };
      case "SELECT_SUSPENSION_CLIENT":
        return {
          ...state,
          selectedClient: action.payload,
        };
      default:
        return state;
    }
  };

  const suspension = (state = suspensionInitialState, action) => {
    let history = [];
    let suspensions = [];

    switch (action.type) {
      case "TOGGLE_SUSPENSION_SUCCESS":
        return {
          ...state,
          suspensionAddedSuccess:
            action.payload == "add"
              ? !state.suspensionAddedSuccess
              : state.suspensionAddedSuccess,
          suspensionUpdatedSuccess:
            action.payload == "update"
              ? !state.suspensionUpdatedSuccess
              : state.suspensionUpdatedSuccess,
          suspensionDeletedSuccess:
            action.payload == "delete"
              ? !state.suspensionDeletedSuccess
              : state.suspensionDeletedSuccess,
        };
      case "GET_SUSPENSION_INIT":
        return {
          ...state,
          selectedSuspension: {},
          resourceLoading: state.resourceLoading.concat(["GET_SUSPENSION"]),
        };
      case "GET_SUSPENSION_SUCCESS":
        return {
          ...state,
          selectedSuspension: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION",
          ),
        };
      case "GET_SUSPENSION_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION",
          ),
        };
      case "CHECK_SUSPENSION_INIT":
        return {
          ...state,
          isSuspendedSuspensionId: null,
          resourceLoading: state.resourceLoading.concat(["CHECK_SUSPENSION"]),
        };
      case "CHECK_SUSPENSION_SUCCESS":
        return {
          ...state,
          isSuspendedSuspensionId: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "CHECK_SUSPENSION",
          ),
        };
      case "CHECK_SUSPENSION_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "CHECK_SUSPENSION",
          ),
        };
      case "SELECT_SUSPENSION":
        return {
          ...state,
          selectedSuspension: action.payload,
        };
      case "GET_SUSPENSIONS_INIT":
        return {
          ...state,
          suspensions: [],
          resourceLoading: state.resourceLoading.concat(["GET_SUSPENSIONS"]),
        };
      case "GET_SUSPENSIONS_SUCCESS":
        return {
          ...state,
          suspensions: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSIONS",
          ),
        };
      case "GET_SUSPENSIONS_ERROR":
        return {
          ...state,
          suspensions: [],
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSIONS",
          ),
        };
      case "GET_SUSPENSION_HISTORY_INIT":
        return {
          ...state,
          suspensionHistory: [],
          resourceLoading: state.resourceLoading.concat([
            "GET_SUSPENSION_HISTORY",
          ]),
        };
      case "GET_SUSPENSION_HISTORY_SUCCESS":
        return {
          ...state,
          suspensionHistory: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_HISTORY",
          ),
        };
      case "GET_SUSPENSION_HISTORY_ERROR":
        return {
          ...state,
          suspensionHistory: [],
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_HISTORY",
          ),
        };
      case "GET_SUSPENSION_TYPES_INIT":
        return {
          ...state,
          suspensionTypes: [],
          resourceLoading: state.resourceLoading.concat([
            "GET_SUSPENSION_TYPES",
          ]),
        };
      case "GET_SUSPENSION_TYPES_SUCCESS":
        return {
          ...state,
          suspensionTypes: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_TYPES",
          ),
        };
      case "GET_SUSPENSION_TYPES_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_TYPES",
          ),
        };
      case "ADD_SUSPENSION_INIT":
        return {
          ...state,
          resourceLoading: state.resourceLoading.concat(["ADD_SUSPENSION"]),
          suspensionAddedSuccess: false,
        };
      case "ADD_SUSPENSION_SUCCESS":
        return {
          ...state,
          suspensionHistory: [action.payload].concat(state.suspensionHistory),
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "ADD_SUSPENSION",
          ),
          suspensionAddedSuccess: true,
        };
      case "ADD_SUSPENSION_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "ADD_SUSPENSION",
          ),
        };
      case "UPDATE_SUSPENSION_INIT":
        return {
          ...state,
          resourceLoading: state.resourceLoading.concat(["UPDATE_SUSPENSION"]),
          suspensionUpdatedSuccess: false,
        };
      case "UPDATE_SUSPENSION_SUCCESS":
        history = state.suspensionHistory.map((s) => {
          return s.suspensionId == action.payload.suspensionId
            ? action.payload
            : s;
        });
        suspensions = state.suspensions.map((s) => {
          return s.suspensionId == action.payload.suspensionId
            ? action.payload
            : s;
        });
        return {
          ...state,
          suspensionHistory: history,
          suspensions: suspensions,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "UPDATE_SUSPENSION",
          ),
          suspensionUpdatedSuccess: true,
        };
      case "UPDATE_SUSPENSION_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "UPDATE_SUSPENSION",
          ),
        };

      case "DELETE_SUSPENSION_INIT":
        return {
          ...state,
          resourceLoading: state.resourceLoading.concat(["DELETE_SUSPENSION"]),
          suspensionDeletedSuccess: false,
        };
      case "DELETE_SUSPENSION_SUCCESS":
        history = state.suspensionHistory.filter((s) => {
          return s.suspensionId !== action.payload.suspensionId;
        });
        suspensions = state.suspensions.filter((s) => {
          return s.suspensionId !== action.payload.suspensionId;
        });
        return {
          ...state,
          suspensionHistory: history,
          suspensions: suspensions,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "DELETE_SUSPENSION",
          ),
          suspensionDeletedSuccess: true,
        };
      case "DELETE_SUSPENSION_ERROR":
        return {
          ...state,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "DELETE_SUSPENSION",
          ),
        };

      case "GET_SUSPENSION_GROUP_MEMBERSHIPS_INIT":
        return {
          ...state,
          resourceLoading: state.resourceLoading.concat([
            "GET_SUSPENSION_GROUP_MEMBERSHIPS",
          ]),
          groupMemberships: [],
          groupMembershipsSuccess: null,
        };
      case "GET_SUSPENSION_GROUP_MEMBERSHIPS_SUCCESS":
        return {
          ...state,
          groupMemberships: action.payload,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_GROUP_MEMBERSHIPS",
          ),
          groupMembershipsSuccess: true,
        };
      case "GET_SUSPENSION_GROUP_MEMBERSHIPS_ERROR":
        return {
          ...state,
          groupMembershipsSuccess: false,
          resourceLoading: state.resourceLoading.filter(
            (r) => r != "GET_SUSPENSION_GROUP_MEMBERSHIPS",
          ),
        };
      default:
        return state;
    }
  };

  return combineReducers({
    client,
    suspension,
  });
}

export default SuspensionReducer();
